import DocumentIcon from '@heroicons/react/outline/esm/DocumentIcon.js'

import { Card } from '@tribeplatform/react-ui-kit/Card'
import { EmptyState as EmptyStateComponent } from '@tribeplatform/react-ui-kit/EmptyState'

import { useI18n } from '../i18n/providers/I18nProvider.js'

export const EmptyState = () => {
  const intl = useI18n()

  return (
    <Card>
      <Card.Content>
        <div className="my-16">
          <EmptyStateComponent
            title={intl.$t({
              id: 'Generics.NothingHereYet',
              defaultMessage: 'Nothing here yet.',
            })}
            icon={<DocumentIcon />}
          />
        </div>
      </Card.Content>
    </Card>
  )
}
